let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h1VUN")).then(() => parcelRequire('eVXmI'));